import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { CODE_STATUS } from '@app/constant/CodeConstant'
import { VOUCHER_TYPE } from '@app/constant/VoucherTypeConstant'
import getParameters from '@app/libs/getParameters'
import { usePage } from '@inertiajs/inertia-react'
import Grid from '@mui/material/Grid'
import { useTranslation } from 'react-i18next'

export default function TransactionReport({ transaction, total, campaign, partnerSearchList }) {
  const { t, i18n } = useTranslation()
  const { url } = usePage()
  const urlObj = new URL(url, location.origin)
  const transactionData = {
    ...transaction,
    data: transaction.data.map((item) => {
      if (VOUCHER_TYPE.PREMIUM === item.type) return { ...item, price: t('TRANSACTION_REPORT.PAID') }
      return item
    }),
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataGrid
          enableIndexColumn
          columns={[
            {
              id: 'voucher_name',
              Header: t('TRANSACTION_REPORT.VOUCHER_NAME'),
              accessor: 'voucher_name',
              type: 'string',
              disableFilters: true,
            },
            {
              id: 'campaigns',
              Header: t('TRANSACTION_REPORT.CAMPAIGN_NAME'),
              accessor: 'campaign',
              options: campaign,
              type: 'multiSelect',
              isVisible: false,
              disableFilters: true,
            },
            {
              id: 'campaign_name',
              Header: t('TRANSACTION_REPORT.CAMPAIGN_NAME'),
              accessor: 'campaign_name',
              type: 'string',
              disableFilters: true,
            },
            {
              id: 'partner_name',
              Header: t('TRANSACTION_REPORT.PARTNER_NAME'),
              accessor: 'partner_name',
              options: partnerSearchList,
              type: 'multiSelect',
              router: 'admin.report.transaction',
              only: 'partnerSearchList',
            },
            {
              id: 'updated_at',
              Header: t('TRANSACTION_REPORT.TIME'),
              accessor: 'updated_at',
              type: 'dateRange',
            },
            {
              id: 'customer_id',
              Header: t('TRANSACTION_REPORT.CUSTOMER_ID'),
              accessor: 'customer_id',
              type: 'string',
              disableFilters: true,
            },
            {
              id: 'type',
              Header: t('TRANSACTION_REPORT.TYPE'),
              accessor: ({ type }) => t(`CODES.${type.toUpperCase()}`),
              type: 'singleSelect',
              typeCategories: 'Type',
              options: [
                { value: VOUCHER_TYPE.STANDARD, name: t('VOUCHERS.STANDARD') },
                { value: VOUCHER_TYPE.PREMIUM, name: t('VOUCHERS.PREMIUM') },
              ],
              disableFilters: true,
            },
            {
              id: 'status',
              Header: t('TRANSACTION_REPORT.STATUS'),
              accessor: ({ status }) => t(`CODES.${status.toUpperCase()}`),
              type: 'singleSelect',
              options: [
                { value: CODE_STATUS.REDEEMED, name: t(`CODES.${CODE_STATUS.REDEEMED_NAME.toUpperCase()}`) },
                { value: CODE_STATUS.USED, name: t(`CODES.${CODE_STATUS.USED_NAME.toUpperCase()}`) },
              ],
            },
            {
              id: 'price',
              Header: t('TRANSACTION_REPORT.PRICE'),
              accessor: 'price',
              type: 'number',
              disableFilters: true,
            },
          ]}
          data={transactionData}
          enableCollapseFilter={false}
          exportable={{
            enableExport: true,
            url: 'admin.report.transaction.export',
            params: { ...getParameters(urlObj), locale: i18n.language },
          }}
          routeName="admin.report.transaction"
          total={total}
        />
      </Grid>
    </Grid>
  )
}
